import { ReactNode } from 'react';
import { layout } from '../../styles/layout';
import { Page } from '../Page';
import { HEADER_HEIGHT } from '../../styles/fixedSizes';
import { tw } from '../../styles/tw';

interface FilterPageLayoutProps {
  title: string;
  canonicalUrl?: string;
  description: ReactNode;
  content: ReactNode;
  hideAdvertisement?: boolean | { desktop?: boolean; mobile?: boolean };
}

const FilterViewLayout = ({ title, description, content, hideAdvertisement, canonicalUrl }: FilterPageLayoutProps) => (
  <Page
    className={tw(layout, 'mx-auto my-0 flex-col justify-start')}
    documentTitle={title}
    canonicalUrl={canonicalUrl}
    overflowY="scroll"
    hideAdvertisement={hideAdvertisement}
  >
    <div className="grid w-full gap-14 lg:mt-6 lg:grid-cols-[0.7fr_2.3fr] lg:gap-6.5 xl:grid-cols-[0.8fr_3.2fr]">
      <div
        style={{ '--header-height': `${HEADER_HEIGHT / 16}rem` }}
        className="mt-5 flex w-full flex-col items-start overflow-y-auto pr-1 lg:sticky lg:top-[calc(var(--header-height)_+_1.5rem)] lg:my-0 lg:h-[calc(100vh_-_var(--header-height)_-_1.5rem)] lg:shrink-0"
      >
        {description}
      </div>
      {content}
    </div>
  </Page>
);

export { FilterViewLayout };
